import { FC } from 'react'

import { SettingsPageLayout } from '../components/SettingsPageLayout'
import {
  Button,
  EmptyState,
  GreyWhite,
  IconPlus,
  IconSignal,
  IndigoIndigo60,
  Link,
  SettingsGroup
} from '@sequencehq/core-components'

import { useQuery } from '@sequencehq/api'

import { SETTINGS_STALE_TIME } from '../settings.constants'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { WebhookCard } from 'SettingsV2/components/notifications/WebhookCard'

export const WebhooksSettingsPage: FC = () => {
  const { data, isError, isLoading } = useQuery(
    dashboard20240730Client.getAllNotificationPolicies,
    undefined,
    {
      staleTime: SETTINGS_STALE_TIME
    }
  )

  const webhooks = data?.items.filter(policy => policy.channel === 'WEBHOOK')

  return (
    <SettingsPageLayout
      header="Webhooks"
      subheader="Create and manage webhooks"
      isError={isError}
      actions={
        <Button
          as={Link.Unstyled}
          to="/settings/webhooks/new"
          variant="primary"
          data-testid="settings.webhooks.new"
          leadingIcon={<IconPlus color={GreyWhite} />}
        >
          New webhook
        </Button>
      }
    >
      <SettingsGroup isLoading={isLoading}>
        {webhooks?.map(policy => (
          <WebhookCard key={policy.id} policy={policy} />
        ))}

        {!webhooks?.length && (
          <EmptyState
            title="No webhooks"
            icon={IconSignal}
            iconSize="sm"
            body={
              <>
                Create webhooks for quoting, billing and invoicing events in
                Sequence,{' '}
                <Link
                  _hover={{ textDecoration: 'none' }}
                  to="https://docs.sequencehq.com/reference/latest/notifications/create-notification-policy"
                  color={IndigoIndigo60}
                  target="_blank"
                >
                  learn more
                </Link>
                .
              </>
            }
          />
        )}
      </SettingsGroup>
    </SettingsPageLayout>
  )
}
